module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f0750f_banner_800x600.99cf3824.png";